import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';
import moment from 'moment';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { OTROS } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { LOGISTICA_ORDEN_COMPRA, LOGISTICA_ORDEN_PRODUCCION } from '../../../common/types/referenciaOrigenType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import { lista_estado_movimiento } from '../../../common/types/ordenCompraEstadoType';
import auth from '../../../common/utility/auth';
import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import entidadService from '../../../service/administracion/entidadService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import proyectoService from '../../../service/administracion/proyectoService';
import ordenCompraService from '../../../service/logistica/ordenCompraService';
import ordenProduccionService from '../../../service/logistica/ordenProduccionService';
import conceptoService from '../../../service/logistica/conceptoService';
import movimientoService from '../../../service/logistica/movimientoService';
import empresaService from '../../../service/administracion/empresaService';
import { lst_tipo_afectacion } from "../../../common/types/tipoAfectacion";

import Header from './Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import FormModalCargaMasiva from './FormModalCargaMasiva';
import BuscarProductoModal from './BuscarProductoModal';
import ImportarOrdenCompraModal from './ImportarOrdenCompraModal';
import ImportarOrdenProduccionModal from './ImportarOrdenProduccionModal';
import AgregarSerieModal from './AgregarSerieModal';
import FormModalVer from './FormModalVer';
import RenombrarProductoModal from './RenombrarProductoModal';
import ImprimirModal from './ImprimirModal';
import DetalleIngreso from './DetalleIngreso';


import { APROBADO } from '../../../common/types/ordenCompraEstadoType';
import { ANULADO } from '../../../common/types/movimientoEstadoType';
import { INGRESO } from '../../../common/types/tipoMovimientoType';

var referenciaCount = 1;

var formValuesOC = {
    detalleProductos: [],
    listaComprobanteDetalle: [],
    listaComprobanteReferencia: [],
    productos: [],
    idOrdenCompra: 0
}

var formValuesOP = {
    detalleProductos: [],
    listaComprobanteDetalle: [],
    listaComprobanteReferencia: [],
    productos: []
}

export default class Index extends PaginationBase {

    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();

        this.state = {
            loadingSource: true,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            almacenAll: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            proyectos: [],
            ordenesCompra: [],
            TipoAlmacen: [],
            entidades: [],
            conceptos: [],
            company: {},
            estados: lista_estado_movimiento,
            onSetFieldsValue: null,
            onGetFieldValue: null,
            filter: {
                idTipoMovimiento: INGRESO.ID,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idEstablecimiento: 0,
                idConcepto: 0,
                idEstado: 0,
                entidad: "",
                idProyecto: 0,
                tipoReporte: 1,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            fetching: false,
            productoVisible: false,
            importarOCVisible: false,
            importarOPVisible: false,
            visibleVer: false,
            cargaMasivaVisible: false,
            renombrarProductoVisible: false,
            agregarSerieVisible: false,
            formValues: this.fetchEmptyFormValues(),
            formValuesCargaMasiva: this.fetchEmptyFormValuesCargaMasiva(),
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            importarOrdenCompraModal: {
                nombre: '',
                dataSource: [],
                dataSourceDetalle: [],
                detalleProductos: []
            },
            importarOrdenProduccionModal: {
                nombre: '',
                dataSource: [],
                dataSourceDetalle: [],
                detalleProductos: []
            },
            renombrarProductoModal: {
                nombre: '',
                idProducto: 0
            },
            agregarSerieModal: {
                serie: '',
                idProducto: 0,
                listaDetalleSerie: []
            },
            imprimirFormValues: {
                file: undefined,
                idMovimiento: 0
            }
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idEstablecimiento: 0,
            idConcepto: 0,
            idEstado: 0,
            entidad: "",
            idProyecto: 0,
            tipoReporte: 1,
            idTipoMovimiento: INGRESO.ID,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });

        if (property = 'tipoReporte') {
            this._handlePagination(filter)
        }
    };

    handleChangeNameProduct = (row) => {
        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.idProducto
            }
        })
    }

    handleOkChangeNameProduct = (value, form) => {
        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== value.idProducto);

        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === value.idProducto)[0];
        currentRow.nombre = value.nombre;
        //console.log(currentRow)
        listaComprobanteDetalle_aux.push(currentRow);

        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();

        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux
            }
        });
    }

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].compraSunat).toFixed(3);
        else
            return '0.000';
    }

    handleChangeForm = async (property, value, form) => {
        if (property === "idEstablecimiento") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    // almacenes: almacenes ? almacenes : []
                },
                almacenAll: almacenes ? almacenes : []
            });
        }
        if (property === "idTipoAlmacen") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const almacenes = this.state.almacenAll.filter(e => e.idTipoAlmacen == value);
            var idEntidad = this.state.formValues.idEntidad;
            if (value == 2) { //Suministros

                if (idEntidad == "") {
                    form.setFieldsValue({ idTipoAlmacen: undefined });
                    dialog.error('Debe seleccionar un Empleado');
                    return false;
                }
                /*  if (idEntidad.trim().length != 8) {
                     form.setFieldsValue({ idEntidad: undefined });
                     dialog.error('Para Suministros se debe seleccionar un Empleado');
                     return false;
                 } */

            } else {
                if (idEntidad == "") {
                    form.setFieldsValue({ idTipoAlmacen: undefined });
                    dialog.error('Debe seleccionar un Proveedor');
                    return false;
                }
                /*    if (idEntidad.trim().length != 11) {
                       form.setFieldsValue({ idEntidad: undefined });
                       dialog.error('Para Suministros se debe seleccionar un Proveedor');
                       return false;
                   } */
            }
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : []
                }
            });
        }

        if (property === "fechaStr") {
            //const dias_vencimiento = this.CalcularDiasVencimiento(value, this.state.formValues.fechaVencimientoStr);
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            const detalleProductos = this.state.formValues.listaComprobanteDetalle;
            for (var i = 0; i < detalleProductos.length; i++) {
                detalleProductos[i].fechaVencimiento = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
                detalleProductos[i].fechaProduccion = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
            }

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                    listaComprobanteDetalle: detalleProductos
                }
            });
        }

        if (property === "idMoneda") {
            const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listasPrecio: listasPrecio ? listasPrecio : []
                }
            });
        }


        if (property === "idEntidad") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : []
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoEntidad: { key: direcciones.length > 0 ? direcciones[0].id : undefined }
                });
            });
        }

        //if (property === "idListaPrecio") {
        //    const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
        //    this.setState({
        //        formValues: {
        //            ...this.state.formValues,
        //            listasPrecio: listasPrecio ? listasPrecio : []
        //        }
        //    });
        //}
    }

    handleChangeFormCargaMasiva = async (property, value, form) => {
        if (property === "idEstablecimiento") {
            this.setState({ formValuesCargaMasiva: { ...this.state.formValuesCargaMasiva, almacenLoading: true } });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValuesCargaMasiva: {
                    ...this.state.formValuesCargaMasiva,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : []
                }
            });
        }

        if (property === "fechaStr") {
            //const dias_vencimiento = this.CalcularDiasVencimiento(value, this.state.formValues.fechaVencimientoStr);
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            const detalleProductos = this.state.formValuesCargaMasiva.listaComprobanteDetalle;
            for (var i = 0; i < detalleProductos.length; i++) {
                detalleProductos[i].fechaVencimiento = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
                detalleProductos[i].fechaProduccion = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
            }

            this.setState({
                formValuesCargaMasiva: {
                    ...this.state.formValuesCargaMasiva,
                    tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                    listaComprobanteDetalle: detalleProductos
                }
            });
        }

        if (property === "idMoneda") {
            const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
            this.setState({
                formValuesCargaMasiva: {
                    ...this.state.formValuesCargaMasiva,
                    listasPrecio: listasPrecio ? listasPrecio : []
                }
            });
        }


        if (property === "idEntidad") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            this.setState({
                formValuesCargaMasiva: {
                    ...this.state.formValuesCargaMasiva,
                    direcciones: direcciones ? direcciones : []
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoEntidad: { key: direcciones.length > 0 ? direcciones[0].id : undefined }
                });
            });
        }
    }


    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idEntidad: 0, //..........................................................OK
            idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: "I001", //............................................... OK
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaProduccionStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            detalleProductos: [],
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoEntidad: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            conceptos: [],
            idOrdenCompra: 0,
            ordenesCompra: [],
            ordenesProduccion: [],
            TipoAlmacen: [],
            idConcepto: 0,
            idTipoAlmacen: 0,
            flagClaim: false,

        }
    }

    fetchEmptyFormValuesCargaMasiva = () => {
        return {
            id: 0,
            idEntidad: 0, //..........................................................OK
            idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: "I001", //............................................... OK
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaProduccionStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoEntidad: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            conceptos: [],
            listaCargaMasiva: [],
            urlCargaMasiva: "",
            idConcepto: 0
        }
    }


    fetchEditFormValues = (value) => {
        //var d = new Date();
        //var _year = d.getFullYear();
        return {
            id: value.movimiento.id,
            idEntidad: value.movimiento.idEntidad, //..........................................................OK
            //idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: value.movimiento.idAlmacen, //..........................................................OK
            idMoneda: value.movimiento.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: value.movimiento.idEstablecimiento, //..........................................................OK
            idProyecto: value.movimiento.idProyecto,
            serie: value.movimiento.serie, //............................................... OK
            documento: value.movimiento.documento, //............................................... OK
            fechaStr: value.movimiento.fechaStr, //......................................... OK
            //fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: value.movimiento.tipoCambio, //..........................................................OK
            observacion: value.movimiento.observacion, //..........................................................OK
            detalleProductos: [],
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            sumaSubTotal: value.movimiento.subTotal,
            sumaIgv: value.movimiento.igv,
            sumaTotal: value.movimiento.total,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoEntidad: value.movimiento.numeroDocumentoEntidad,
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            conceptos: [],
            idOrdenCompra: 0,
            ordenesCompra: [],
            listaCargaMasiva: [],
            idConcepto: value.movimiento.idConcepto,
            idTipoAlmacen: value.movimiento.idTipoAlmacen,
            razonSocialEntidad: value.movimiento.razonSocialEntidad,
            nombreEstablecimiento: value.movimiento.nombreEstablecimiento,
            nombreAlmacen: value.movimiento.nombreAlmacen,
            nombreConcepto: value.movimiento.nombreConcepto,
            nombreTipoMovimiento: value.movimiento.nombreTipoMovimiento,
            nombreMoneda: value.movimiento.nombreMoneda,
            nombreProyecto: value.movimiento.nombreProyecto
        }
    }

    fetchEmptyFormResetValues = () => {
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: 0,
            idEntidad: 0, //..........................................................OK
            idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: _year, //............................................... OK
            documento: "", //............................................... OK
            //fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            //fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoEntidad: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            conceptos: [],
            idOrdenCompra: 0,
            ordenesCompra: [],
            TipoAlmacen: [],
            idConcepto: 0,
        }
    }

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            serie: "",
            documento: "",
            flagInterno: true
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (id) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            },
        });
    }

    handleBuscarProducto = () => {
        this.setState({
            productoVisible: true,
            productoModal: {
                ...this.state.productoModal,
                dataSource: this.state.productos,
                selectedRowKeys: this.state.formValues.listaComprobanteDetalle.map(function (v) {
                    return v.idProducto;
                })
            }
        });
    }

    handleChangeProductoModal = (value) => {
        const dataSource = this.state.productos.filter(item => {
            return (item.codigoReferencia + ' - ' + item.nombre)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            productoModal: {
                ...this.state.productoModal,
                dataSource: dataSource
            }
        });
    };

    getMinDate = (value) => {
        var arrayD1 = value.split('/');
        var minDate = arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0];

        return minDate;
    }

    handleScaner = async (value, onSetFieldsValue, onGetFieldValue, onCalculateDetail) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });

        if (this.state.agregarSerieVisible) // SE AGREGA SERIE MENDIANTE EL POPUP ASIGNAR SERIE
        {
            debugger;

            this.handleAgregarSerieDetalle({ idProducto: this.state.agregarSerieModal.idProducto, serie: value, onCalculateDetail: onCalculateDetail });

            return;
        }

        // BUSQUEDA DE PRODUCTO POR CODIGO DE BARRA

        var flagPrecioIncluyeIGV = false;
        var porcentajeIGV = 18;

        /* LSITA */
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var filter_detalle = listaComprobanteDetalle.filter((m) => m.codigoBarra === value);
        const index = listaComprobanteDetalle.map(i => i.codigoBarra).indexOf(value);


        var item = {};
        if (filter_detalle.length > 0) {
            listaComprobanteDetalle = listaComprobanteDetalle.filter((m) => m.codigoBarra !== value);
            var item = filter_detalle[0];

            if (item.flagAplicarSerie) {
                dialog.error("El producto ya se encuentra agregado.");
                return;
            }

            var _precioUnitario = this.state.onGetFieldValue(`arrPrecioUnitario[${item.identifier}]`);
            var _cantidad = this.state.onGetFieldValue(`arrCantidad[${item.identifier}]`);

            item.cantidad = parseInt(_cantidad,) + 1;
            item.precioUnitario = (_precioUnitario == undefined || _precioUnitario == null) ? 0 : parseFloat(_precioUnitario);
        } else {


            var list = await productoService.listarBarras(value);

            var filter_list = list.filter((m) => m.codigoBarra === value);

            if (filter_list.length === 0) {
                dialog.error("No existe el producto con codigo " + value);
                return;
            }
            var row = filter_list[0];

            item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.id,
                idTipoProducto: row.idTipoProducto,
                codigo: row.codigoReferencia,
                codigoBarra: row.codigoBarra,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                flagAplicarSerie: row.flagAplicarSerie,
                flagAfecto: row.flagIGVAfecto,
                flagGratuito: row.flagGratuito,
                flagISC: row.flagISC,
                flagExonerado: row.flagExonerado,
                isc: 0,
                flagVencimiento: row.flagVencimiento,
                fechaVencimiento: row.flagVencimiento ? global.fetchCurrentDateStr() : null,
                fechaProduccion: global.fetchCurrentDateStr(),
                precioUnitario: 0,
                precioNuevo: 0,
                precioUnitarioSinIGV: 0,
                cantidad: row.flagAplicarSerie ? 0 : 1,
                totalDetalle: 0,
                numeroLote: '',
                porcentajeDescuento: 0,
                importeDescuento: 0,
                subTotal: 0,
                igv: 0,
                total: 0,
                listaDetalleSerie: []
            };
        }

        /* CALCULOS */
        var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;

        item.totalDetalle = item.cantidad * item.precioUnitario;
        item.subTotal = item.cantidad * item.precioUnitario;
        item.igv = parseFloat(item.flagAfecto ? item.subTotal * (porcentajeIGV / 100) : 0);
        item.total = item.subTotal + item.igv;
        /* CALCULOS */

        listaComprobanteDetalle.splice(index, 0, item);

        var detalleProductos = this.state.onGetFieldValue("detalleProductos");
        detalleProductos = detalleProductos.filter((m) => m.identifier !== item.identifier);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                    detalleProductos: listaComprobanteDetalle,
                    sumaSubTotal: detalleProductos.reduce((a, b) => a + (b["subTotal"] || 0), 0),
                    sumaIgv: detalleProductos.reduce((a, b) => a + (b["igv"] || 0), 0),
                    sumaTotal: detalleProductos.reduce((a, b) => a + (b["total"] || 0), 0),
                },
            },
            () => {

                var producto = {
                    identifier: item.identifier,
                    idProducto: item.idProducto,
                    idTipoProducto: item.idTipoProducto,
                    codigo: item.codigoReferencia,
                    codigoBarra: item.codigoBarra,
                    nombre: item.nombre,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    flagAplicarSerie: item.flagAplicarSerie,
                    flagAfecto: item.flagIGVAfecto,
                    flagGratuito: item.flagGratuito,
                    flagISC: item.flagISC,
                    flagExonerado: item.flagExonerado,
                    isc: item.isc,
                    flagVencimiento: item.flagVencimiento,
                    fechaVencimiento: item.fechaVencimiento,
                    fechaProduccion: item.fechaProduccion,
                    precioUnitario: item.precioUnitario,
                    precioNuevo: item.precioNuevo,
                    precioUnitarioSinIGV: item.precioUnitarioSinIGV,
                    cantidad: item.cantidad,
                    totalDetalle: item.totalDetalle,
                    numeroLote: item.numeroLote,
                    porcentajeDescuento: item.porcentajeDescuento,
                    importeDescuento: item.importeDescuento,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    total: item.total,
                };



                detalleProductos.splice(index, 0, producto);

                this.state.onSetFieldsValue({
                    [`arrCantidad[${item.identifier}]`]: item.cantidad.toFixed(3),
                    [`arrSubTotal[${item.identifier}]`]: item.subTotal.toFixed(2),
                    [`arrIgv[${item.identifier}]`]: item.igv.toFixed(2),
                    [`arrTotal[${item.identifier}]`]: item.total.toFixed(2),
                    sumaSubTotal: detalleProductos.reduce((a, b) => a + (b["subTotal"] || 0), 0),
                    sumaIgv: detalleProductos.reduce((a, b) => a + (b["igv"] || 0), 0),
                    sumaTotal: detalleProductos.reduce((a, b) => a + (b["total"] || 0), 0),
                    detalleProductos: detalleProductos,
                });
            }
        );
        message.success("Producto agregado");

    };



    handleChangeSelectedRowKey = (selected, rows) => {
        debugger;
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        rows.forEach(item => {
            var filter = this.state.formValues.listaComprobanteDetalle.filter(m => { return m.idProducto === item.id; });
            if (filter.length === 0) {
                listaComprobanteDetalle.push({
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.id,
                    nombre: item.nombre,
                    codigoBarra: item.codigoBarra,
                    cantidad: 0,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: 0,
                    precioNuevo: 0,
                    total: 0,
                    flagAfecto: item.flagIGVAfecto,
                    flagExonerado: item.flagExonerado,
                    precioUnitarioSinIGV: 0,
                    subTotal: 0,
                    igv: 0,
                    flagVencimiento: item.flagVencimiento,
                    flagAplicarSerie: item.flagAplicarSerie,
                    fechaVencimiento: item.flagVencimiento ? global.fetchCurrentDateStr() : null,
                    fechaProduccion: this.state.formValues.fechaStr,
                    minFechaStr: this.getMinDate(this.state.formValues.fechaStr),
                    lote: '',
                    numeroRegistroSanitario: '',
                    idImpuesto: item.idImpuesto,
                    listaDetalleSerie: []

                })
            }
        });

        listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle,
                detalleProductos: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selected
            }
        });
    };

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleBuscarProducto();

            if (this.state.formValues.activeKey === "2")
                this.handleAddReferencia();
        });
    };


    handleRemoverProducto = (row, form) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
            },
        }, () => {
            var detalleProductos = form.getFieldValue('detalleProductos');
            form.setFieldsValue({
                detalleProductos: detalleProductos.filter(m => m.identifier !== row.identifier)
            });
        });
    };

    handleOnChangeEntidad = async (value, form) => {
        debugger
        //const numeroDoc = value.props.children.split('-')[value.props.children.split('-').length - 1];
        this.setState({
            formValues: {
                ...this.state.formValues,
                //documentoEntidad: numeroDoc,
                idEntidad: value,
                direcciones: []
            }
        });

        form.setFieldsValue({ idTipoAlmacen: { key: undefined } });
        form.setFieldsValue({ idEntidad: value });


        const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(value);
        if (direccionesEstablecimientos === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    //clienteLoading: false,
                    //clientes: [],
                    direcciones: [],
                    documentoEntidad: ''
                }
            });
        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direccionesEstablecimientos
                }
            });
        }
    }


    handleSearchClientes = async (value) => {
        if (!value) return;

        this.setState({ fetching: true });

        setTimeout(async () => {
            const response = await entidadService.search({ valor: value });

            if (response !== undefined) {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        clienteLoading: false,
                        entidades: response,
                        direcciones: [],
                    },
                    formValuesCargaMasiva: {
                        ...this.state.formValuesCargaMasiva,
                        entidades: response,
                    },
                    fetching: false
                });
            }
        }, 800);

    };

    handleImportarOC = async (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, async () => {
            var filterSearchOC = {
                idEstadoRequerimiento: APROBADO,
                filtro: ''
            };
            var ordenesCompra = await ordenCompraService.listarPorEstado(filterSearchOC);
            this.setState({
                importarOCVisible: true,
                importarOrdenCompraModal: {
                    ...this.state.importarOrdenCompraModal,
                    idOrdenCompra: 0,
                    dataSource: ordenesCompra,
                    dataSourceDetalle: []
                }
            });
        });
    }

    handleImportarOP = async (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, async () => {
            var filterSearchOC = {
                idEstadoRequerimiento: APROBADO,
                filtro: ''
            };
            var ordenesProduccion = await ordenProduccionService.listarPorEstado(filterSearchOC);
            this.setState({
                importarOPVisible: true,
                importarOrdenProduccionModal: {
                    ...this.state.importarOrdenProduccionModal,
                    dataSource: ordenesProduccion,
                    dataSourceDetalle: []
                }
            });
        });
    }

    handleNew = async () => {
        var idSoles = SOLES;
        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
        formValues.establecimientos = this.state.establecimientos;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.proyectos = this.state.proyectos;
        formValues.conceptos = this.state.conceptos;
        formValues.entidades = this.state.entidades;
        formValues.TipoAlmacen = this.state.TipoAlmacen;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        formValues.flagClaim = this.state.company.idTipoEmpresa == 2 ? true : false;

        var productos = await productoService.listar();
        var productos_filter = productos.filter(m => m.idTipoProducto === 1);
        this.setState({
            visible: true,
            formValues,
            productos: productos_filter ? productos_filter : [],
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: []
            },
            ordenesCompra: [],
            importarOrdenCompraModal: {
                ...this.state.importarOrdenCompraModal,
                dataSource: [],
                selectedRowKeys: []
            }
        });
    }

    handleNewCargaMasiva = async () => {
        var idSoles = SOLES;
        var formValuesCargaMasiva = this.fetchEmptyFormValuesCargaMasiva();
        formValuesCargaMasiva.monedas = this.state.monedas;
        formValuesCargaMasiva.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValuesCargaMasiva.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
        formValuesCargaMasiva.establecimientos = this.state.establecimientos;
        formValuesCargaMasiva.idListaPrecio = formValuesCargaMasiva.listasPrecio.length === 0 ? 0 : formValuesCargaMasiva.listasPrecio[0].id;
        formValuesCargaMasiva.tiposComprobante = this.state.tiposComprobante;
        formValuesCargaMasiva.proyectos = this.state.proyectos;
        formValuesCargaMasiva.conceptos = this.state.conceptos.filter(m => m.id === 16);//SALDO INICIAL
        formValuesCargaMasiva.entidades = this.state.entidades;

        var productos = await productoService.listarPorIdListaPrecio(formValuesCargaMasiva.idListaPrecio);

        this.setState({
            cargaMasivaVisible: true,
            formValuesCargaMasiva,
            productos: productos ? productos : []
        });
    }


    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0 || values.id === undefined)
                response = await movimientoService.registrar(values);
            else
                response = await movimientoService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormResetValues();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveCargaMasiva = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            response = await movimientoService.registrarCargaMasiva(values);
            if (response.status === 200) {
                var empty = this.fetchEmptyFormValuesCargaMasiva();
                this.setState({ cargaMasivaVisible: false, formValuesCargaMasiva: empty });
                form.resetFields();

                message.success('Registrado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleExportExcel = async () => {
        var response = await movimientoService.excel(this.state.filter);
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Ingresos.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await movimientoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Ingresos.pdf");
    }

    handleDetalleExportExcel = async () => {
        this.setState({ loadingExcel: true });

        var response = await movimientoService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });

        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Ingresos Detallado.xlsx");
    }

    handleDetalleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await movimientoService.pdfDetallado(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Ingresos Detallado.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await movimientoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleImprimir = async (item) => {
        var file = undefined;
        var response = await movimientoService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idOrdenCompra: item.id
            }
        });
    };

    handleEdit = async (values) => {
        const response = await movimientoService.obtenerPorId(values.id);
        if (response !== undefined) {
            var filterSearchOC = {
                idEstadoRequerimiento: APROBADO,
                filtro: ''
            };
            var formValues = this.fetchEditFormValues(response);
            formValues.monedas = this.state.monedas;
            formValues.establecimientos = this.state.establecimientos;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.conceptos = this.state.conceptos;
            formValues.flagClaim = this.state.company.idTipoEmpresa == 2 ? true : false;
            formValues.tipoAfectacion = lst_tipo_afectacion;

            var ordenesCompra = await ordenCompraService.listarPorEstado(filterSearchOC);

            const almacenes = await almacenService.listarPorIdEstablecimiento(response.movimiento.idEstablecimiento);

            formValues.entidades = this.state.entidades;
            formValues.almacenes = almacenes;
            const products = [];
            for (var i = 0; i < response.movimientoDetalles.length; i++) {
                var item = response.movimientoDetalles[i];
                const identifier = global.fetchUniqueCode();
                var oneProd = {
                    identifier: identifier,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    codigoBarra: item.codigoBarra,
                    numeroRegistroSanitario: item.numeroRegistroSanitario,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    lote: item.numeroLote,
                    fechaVencimiento: item.fechaVencimientoStr,
                    fechaProduccion: item.fechaProduccionStr,
                    idImpuesto: item.idImpuesto,

                }

                formValues.listaComprobanteDetalle.push(oneProd);


                var detalleProducto = {
                    identifier: identifier,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigoBarra: item.codigoBarra,
                    numeroRegistroSanitario: item.numeroRegistroSanitario,
                    fechaVencimiento: item.fechaVencimientoStr,
                    fechaProduccion: item.fechaProduccionStr,
                    flagAfecto: item.flagAfecto,
                    idProducto: item.idProducto,
                    igv: item.igv,
                    lote: item.numeroLote,
                    precioUnitario: item.precioUnitario,
                    subTotal: item.subTotal,
                    total: item.total,
                    idImpuesto: item.idImpuesto,

                };

                formValues.detalleProductos.push(detalleProducto);
                products.push(item.idProducto);
            }

            for (var i = 0; i < response.movimientoReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.movimientoReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.idReferencia,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }
            console.log(formValues);

            this.setState({
                formValues,
                visible: true,
                // productos: productos ? productos : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: []
                },
                ordenesCompra: ordenesCompra ? ordenesCompra : [],
                importarOrdenCompraModal: {
                    ...this.state.importarOrdenCompraModal,
                    selectedRowKeys: []
                }
            });
        }
    }

    handleVer = async (values) => {

        const response = await movimientoService.obtenerPorId(values.id);

        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);
            //console.log(formValues)
            const almacenes = await almacenService.listarPorIdEstablecimiento(response.movimiento.idEstablecimiento);

            for (var i = 0; i < response.movimientoDetalles.length; i++) {
                var item = response.movimientoDetalles[i];

                const listaCompraDetalleSerie = [];

                response.movimientoDetalleSerie.forEach((detalleSerie) => {
                    if (detalleSerie.idProducto === item.idProducto) {
                        listaCompraDetalleSerie.push({
                            // identifier: global.fetchUniqueCode(),
                            idProducto: detalleSerie.idProducto,
                            serie: detalleSerie.serie
                        });
                    }
                });

                var oneProd = {
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: item.valorUnitario,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    tipoImpuesto: item.tipoImpuesto,
                    lote: item.numeroLote,
                    numeroRegistroSanitario: item.numeroRegistroSanitario,
                    fechaProduccion: item.fechaProduccionStr,
                    fechaVencimiento: item.fechaVencimientoStr,
                    detalleSeries: listaCompraDetalleSerie.map(u => u.serie).join(', '),
                    listaCompraDetalleSerie: listaCompraDetalleSerie
                }

                formValues.listaComprobanteDetalle.push(oneProd);

            }

            for (var i = 0; i < response.movimientoReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.movimientoReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }
            formValues.almacenes = almacenes;
            formValues.TipoAlmacen = this.state.TipoAlmacen;
            this.setState({
                visibleVer: true,
                formValues
            });
        }
    }

    handleAnular = async (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                id: values.id,
                idMovimientoEstado: ANULADO
            };
            var response = await movimientoService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleSelectRowOrdenCompra = async (row) => {
        ;
        const response = await ordenCompraService.obtenerPorId(row.id);
        if (response !== undefined) {
            formValuesOC.idMoneda = response.ordenCompra.idMoneda;
            formValuesOC.subTotal = response.ordenCompra.subTotal;
            formValuesOC.igv = response.ordenCompra.igv;
            formValuesOC.total = response.ordenCompra.total;
            formValuesOC.idEntidad = response.ordenCompra.idEntidadProveedor;
            formValuesOC.idEstablecimiento = response.ordenCompra.idEstablecimiento;
            formValuesOC.idAlmacen = response.ordenCompra.idAlmacen;
            formValuesOC.productos = [];
            formValuesOC.detalleProductos = [];
            formValuesOC.listaComprobanteDetalle = [];
            formValuesOC.listaComprobanteReferencia = [];
            formValuesOC.idOrdenCompra = row.id;

            for (var i = 0; i < response.ordenCompraDetalles.length; i++) {
                var item = response.ordenCompraDetalles[i];
                var identifier = global.fetchUniqueCode();
                var oneProd = {
                    identifier: identifier,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    fechaProduccionStr: this.state.formValues.fechaStr,
                    fechaVencimientoStr: this.state.formValues.fechaStr,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv
                }

                formValuesOC.productos.push(item.idProducto);
                formValuesOC.listaComprobanteDetalle.push(oneProd);

                var detalleProducto = {
                    identifier: identifier,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    fechaProduccion: this.state.formValues.fechaStr,
                    fechaVencimiento: this.state.formValues.fechaStr,
                    flagAfecto: item.flagAfecto,
                    idProducto: item.idProducto,
                    igv: item.igv,
                    lote: item.numeroLote,
                    numeroRegistroSanitario: item.numeroRegistroSanitario,
                    precioUnitario: item.precioUnitario,
                    subTotal: item.subTotal,
                    total: item.total
                };

                formValuesOC.detalleProductos.push(detalleProducto);
            }

            var oneRef = {
                identifier: global.fetchUniqueCode(),
                idReferencia: response.ordenCompra.id,
                idReferenciaOrigen: LOGISTICA_ORDEN_COMPRA,
                idTipoComprobante: response.ordenCompra.idTipoComprobante,
                serie: response.ordenCompra.serie,
                documento: response.ordenCompra.documento,
                flagInterno: true
            }

            formValuesOC.listaComprobanteReferencia.push(oneRef);
            ;
            this.setState({
                importarOCVisible: true,
                importarOrdenCompraModal: {
                    ...this.state.importarOrdenCompraModal,
                    dataSourceDetalle: formValuesOC.listaComprobanteDetalle,
                    detalleProductos: formValuesOC.detalleProductos
                }
            })
        }
    }

    handleOkImportarOrdenCompra = async (values, form) => {
        if (formValuesOC === null || formValuesOC === undefined || formValuesOC.idOrdenCompra === 0) {
            dialog.warning("Seleccione una orden de compra;");
            return;
        }

        const almacenes = await almacenService.listarPorIdEstablecimiento(formValuesOC.idEstablecimiento);


        this.setState({
            visible: true,
            importarOCVisible: false,
            formValues: {
                ...this.state.formValues,
                idConcepto: 2,//COMPRA NACIONAL
                idOrdenCompra: formValuesOC.idOrdenCompra,
                idEntidad: formValuesOC.idEntidad,
                idMoneda: formValuesOC.idMoneda,
                idEstablecimiento: formValuesOC.idEstablecimiento,
                idAlmacen: formValuesOC.idAlmacen,
                sumaSubTotal: formValuesOC.subTotal,
                sumaIgv: formValuesOC.igv,
                sumaTotal: formValuesOC.total,
                almacenes: almacenes,
                detalleProductos: formValuesOC.detalleProductos,
                listaComprobanteDetalle: formValuesOC.listaComprobanteDetalle,
                listaComprobanteReferencia: formValuesOC.listaComprobanteReferencia,
                activeKey: "2"
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: formValuesOC.productos
            }
        }, () => {
            this.state.onSetFieldsValue({
                idEntidad: formValuesOC.idEntidad !== 0 ? { key: formValuesOC.idEntidad } : undefined,
                idEstablecimiento: { key: formValuesOC.idEstablecimiento },
                idAlmacen: { key: formValuesOC.idAlmacen },
                idMoneda: { key: formValuesOC.idMoneda },
                detalleProductos: formValuesOC.detalleProductos,
                sumaSubTotal: formValuesOC.subTotal,
                sumaIgv: formValuesOC.igv,
                sumaTotal: formValuesOC.total
            });
        });
    }


    handleSelectRowOrdenProduccion = async (row) => {
        const response = await ordenProduccionService.obtenerPorId(row.id);
        if (response !== undefined) {
            formValuesOP.subTotal = response.ordenProduccion.subTotal;
            formValuesOP.igv = response.ordenProduccion.igv;
            formValuesOP.total = response.ordenProduccion.total;
            formValuesOP.idEntidad = response.ordenProduccion.idEntidadProveedor;
            formValuesOP.idEstablecimiento = response.ordenProduccion.idEstablecimiento;
            formValuesOP.idAlmacen = response.ordenProduccion.idAlmacen;
            formValuesOP.idMoneda = response.ordenProduccion.idMoneda;
            formValuesOP.productos = [];
            formValuesOP.detalleProductos = [];
            formValuesOP.listaComprobanteDetalle = [];
            formValuesOP.listaComprobanteReferencia = [];
            formValuesOP.idOrdenProduccion = row.id;

            for (var i = 0; i < response.ordenProduccionDetalles.length; i++) {
                var item = response.ordenProduccionDetalles[i];
                var identifier = global.fetchUniqueCode();
                var oneProd = {
                    identifier: identifier,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    fechaProduccion: this.state.formValues.fechaStr,
                    fechaVencimiento: this.state.formValues.fechaStr,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv
                }

                formValuesOP.productos.push(item.idProducto);
                formValuesOP.listaComprobanteDetalle.push(oneProd);

                var detalleProducto = {
                    identifier: identifier,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    fechaProduccion: this.state.formValues.fechaStr,
                    fechaVencimiento: this.state.formValues.fechaStr,
                    flagAfecto: item.flagAfecto,
                    idProducto: item.idProducto,
                    igv: item.igv,
                    lote: item.numeroLote,
                    numeroRegistroSanitario: item.numeroRegistroSanitario,
                    precioUnitario: item.precioUnitario,
                    subTotal: item.subTotal,
                    total: item.total
                };

                formValuesOP.detalleProductos.push(detalleProducto);
            }

            var oneRef = {
                identifier: global.fetchUniqueCode(),
                idReferencia: response.ordenProduccion.id,
                idReferenciaOrigen: LOGISTICA_ORDEN_PRODUCCION,
                idTipoComprobante: response.ordenProduccion.idTipoComprobante,
                serie: response.ordenProduccion.serie,
                documento: response.ordenProduccion.documento,
                flagInterno: true
            }

            formValuesOP.listaComprobanteReferencia.push(oneRef);

            this.setState({
                importarOPVisible: true,
                importarOrdenProduccionModal: {
                    ...this.state.importarOrdenProduccionModal,
                    dataSourceDetalle: formValuesOP.listaComprobanteDetalle,
                    detalleProductos: formValuesOP.detalleProductos
                }
            })
        }
    }

    handleOkImportarOrdenProduccion = async (values, form) => {
        if (formValuesOP === null || formValuesOP === undefined || formValuesOP.idOrdenProduccion === 0) {
            dialog.warning("Seleccione una orden de producción;");
            return;
        }

        const almacenes = await almacenService.listarPorIdEstablecimiento(formValuesOP.idEstablecimiento);

        this.setState({
            visible: true,
            importarOPVisible: false,
            formValues: {
                ...this.state.formValues,
                idConcepto: 19,//ENTRADA PRODUCCION
                idEntidad: formValuesOP.idEntidad,
                idEstablecimiento: formValuesOP.idEstablecimiento,
                idAlmacen: formValuesOP.idAlmacen,
                idMoneda: formValuesOP.idMoneda,
                sumaSubTotal: formValuesOP.subTotal,
                sumaIgv: formValuesOP.igv,
                sumaTotal: formValuesOP.total,
                almacenes: almacenes,
                detalleProductos: formValuesOP.detalleProductos,
                listaComprobanteDetalle: formValuesOP.listaComprobanteDetalle,
                listaComprobanteReferencia: formValuesOP.listaComprobanteReferencia,
                activeKey: "2"
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: formValuesOP.productos
            }
        }, () => {
            this.state.onSetFieldsValue({
                idEntidad: formValuesOP.idEntidad !== 0 ? { key: formValuesOP.idEntidad } : undefined,
                idEstablecimiento: { key: formValuesOP.idEstablecimiento },
                idAlmacen: { key: formValuesOP.idAlmacen },
                idMoneda: { key: formValuesOP.idMoneda },
                detalleProductos: formValuesOP.detalleProductos,
                sumaSubTotal: formValuesOP.subTotal,
                sumaIgv: formValuesOP.igv,
                sumaTotal: formValuesOP.total
            });
        });
    }

    handleAgregarSerie = async (row, onCalculateDetail, setFieldsValueDetalle, getFieldValueDetalle) => {
        debugger;
        this.setState({
            setFieldsValueDetalle,
            getFieldValueDetalle
        }, async () => {
            debugger;
            this.setState({
                agregarSerieVisible: true,
                agregarSerieModal: {
                    ...this.state.agregarSerieModal,
                    idProducto: row.idProducto,
                    codigoProducto: row.codigo,
                    nombreProducto: row.nombre,
                    serie: '',
                    listaDetalleSerie: row.listaDetalleSerie,
                    onCalculateDetail: onCalculateDetail,
                    setFieldsValueDetalle: setFieldsValueDetalle,
                    getFieldValueDetalle: getFieldValueDetalle
                }
            });

        });
    }

    handleAgregarSerieDetalle = async (form) => {

        debugger;
        var params = auth.user().parametros;
        var listaDetalle = this.state.formValues.detalleProductos;
        var listaDetalleSerie = [];

        /*VALIDAR EXISTE SERIE EN MOVIMIENTOS*/

        var result = await movimientoService.serieValidarExistencia({ idProducto: form.idProducto, serie: form.serie });

        if (result.flagExiste) {
            dialog.error("La serie ya ha sido registrado en una compra.");
            return;
        }


        listaDetalle.forEach(detalle => {
            if (detalle.idProducto === form.idProducto) {

                if (detalle.listaDetalleSerie.filter(m => m.serie === form.serie).length > 0) {
                    dialog.error("La serie ya se encuentra agregada.");
                } else {
                    detalle.listaDetalleSerie.push({
                        identifier: global.fetchUniqueCode(),
                        idProducto: form.idProducto,
                        serie: form.serie
                    });
                }
                debugger;
                detalle.detalleSeries = detalle.listaDetalleSerie.map(u => u.serie).join(', ');
                detalle.cantidad = detalle.listaDetalleSerie.length;

                listaDetalleSerie = detalle.listaDetalleSerie;

                form.onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3);
            }
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaCompranteDetalle: listaDetalle,
                detalleProductos: listaDetalle
            },
            agregarSerieModal: {
                ...this.state.agregarSerieModal,
                listaDetalleSerie: listaDetalleSerie,
                serie: ''
            }
        });
    }

    handleRemoverSerieDetalle = (item, onCalculateDetail) => {
        debugger;
        var listaDetalle = this.state.formValues.detalleProductos;
        var listaDetalleSerie = [];

        listaDetalle.forEach(detalle => {
            if (detalle.idProducto === item.idProducto) {

                detalle.listaDetalleSerie = detalle.listaDetalleSerie.filter(m => m.identifier !== item.identifier);
                detalle.detalleSeries = detalle.listaDetalleSerie.map(u => u.serie).join(', ');
                detalle.cantidad = detalle.listaDetalleSerie.length;

                listaDetalleSerie = detalle.listaDetalleSerie;

                onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3);
            }
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaDetalle,
                detalleProductos: listaDetalle
            },
            agregarSerieModal: {
                ...this.state.agregarSerieModal,
                listaDetalleSerie: listaDetalleSerie,
                serie: ''
            }
        });
    };

    handleDownloadFormatoCargaMasiva = async () => {
        var response = await movimientoService.formatoCargaMasiva();
        if (response !== undefined)
            global.dowloadFile(response.data, "template-carga-masiva-ingreso.xlsx");
    };

    async componentDidMount() {
        const empresa = await empresaService.obtenerPrincipal(0);

        this._initPagination(this.state.filter, movimientoService.paginacion);

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        //const establecimientos = await establecimientoService.principales();
        //const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const proyectos = await proyectoService.listar();
        const conceptos = await conceptoService.listar();
        //const entidades = await entidadService.listar();
        //const proveedor_empleado = entidades.filter(item => item.isProveedor || item.isEmpleado);

        const almacen = await almacenService.listarPorIdEstablecimiento(-1);

        const tipoAlmacen = await almacenService.listaTipoEstablecimiento('000001')

        this.setState({
            loadingSource: false,
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            monedas: monedas ? monedas : [],
            listasPrecio: listasPrecio ? listasPrecio : [],
            establecimientos: establecimientos ? establecimientos : [],
            //entidades: entidades ? entidades : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            proyectos: proyectos ? proyectos : [],
            conceptos: conceptos ? conceptos.filter(m => { return m.idTipoMovimiento === INGRESO.ID; }) : [],
            TipoAlmacen: tipoAlmacen ? tipoAlmacen : [],
            almacenes: almacen ? almacen : [],
            company: empresa
        });
    }

    render() {
        return (
            <div>
                <Header
                    title={this.state.filter.tipoReporte == 1 ? "Ingresos" : "Ingresos Detallado"}
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onNewCargaMasiva={this.handleNewCargaMasiva}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    entidades={this.state.entidades}
                    almacenes={this.state.almacenes}
                    conceptos={this.state.conceptos}
                    proyectos={this.state.proyectos}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />


                {this.state.filter.tipoReporte == 1 ?
                    <ResultList
                        pagination={this.state.pagination}
                        loadingEdit={this.state.loadingSource}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onPrint={this.handlePrint}
                        onVer={this.handleVer}
                        onEditar={this.handleEdit}
                        onAnular={this.handleAnular}
                        onImprimir={this.handleImprimir}
                        onChange={this._handleChangePagination}
                    /> :
                    <DetalleIngreso
                        pagination={this.state.pagination}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        onExportExcel={this.handleDetalleExportExcel}
                        onExportPdf={this.handleDetalleExportPdf}
                        onVer={this.handleVer}
                        onImprimir={this.handleImprimir}
                        onChange={this._handleChangePagination}
                    />

                }
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarEntidad={this.handleBuscarEntidad}
                    onChangeEntidad={this.handleOnChangeEntidad}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onImportarOrdenCompra={this.handleImportarOC}
                    onImportarOrdenProduccion={this.handleImportarOP}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onAgregarSerie={this.handleAgregarSerie}
                    onScanerProduct={this.handleScaner}
                    onBlur={this.handleChangeForm}
                    fetching={this.state.fetching}
                    fetchClientes={this.handleSearchClientes}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                />

                <FormModalCargaMasiva
                    visible={this.state.cargaMasivaVisible}
                    formValues={this.state.formValuesCargaMasiva}
                    onBuscarEntidad={this.handleBuscarEntidad}
                    onDownloadFormatoCargaMasiva={this.handleDownloadFormatoCargaMasiva}
                    onChangeEntidad={this.handleOnChangeEntidad}
                    onChangeTab={this.handleChangeTab}
                    onUploadFile={movimientoService.subirCargaMasiva}
                    onChange={this.handleChangeFormCargaMasiva}
                    onBlur={this.handleChangeFormCargaMasiva}
                    onClose={() => this.setState({ cargaMasivaVisible: false })}
                    onSave={this.handleSaveCargaMasiva}
                    fetching={this.state.fetching}
                    fetchClientes={this.handleSearchClientes}
                />

                <BuscarProductoModal
                    visible={this.state.productoVisible}
                    formValues={this.state.productoModal}
                    onChange={this.handleChangeProductoModal}
                    onChangeRow={this.handleChangeSelectedRowKey}
                    onCancel={() => this.setState({ productoVisible: false })}
                />
                <ImportarOrdenCompraModal
                    visible={this.state.importarOCVisible}
                    formValues={this.state.importarOrdenCompraModal}
                    onCancel={() => this.setState({ importarOCVisible: false })}
                    onChangeRow={this.handleSelectRowOrdenCompra}
                    onHandleOkImportarOrdenCompra={this.handleOkImportarOrdenCompra}
                />

                <ImportarOrdenProduccionModal
                    visible={this.state.importarOPVisible}
                    formValues={this.state.importarOrdenProduccionModal}
                    onCancel={() => this.setState({ importarOPVisible: false })}
                    onChangeRow={this.handleSelectRowOrdenProduccion}
                    onHandleOkImportarOrdenProduccion={this.handleOkImportarOrdenProduccion}
                />

                <AgregarSerieModal
                    visible={this.state.agregarSerieVisible}
                    formValues={this.state.agregarSerieModal}
                    onCancel={() => this.setState({ agregarSerieVisible: false })}
                    onAgregarSerieDetalle={this.handleAgregarSerieDetalle}
                    onRemove={this.handleRemoverSerieDetalle}
                />

                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <RenombrarProductoModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
            </div>
        )
    }
}